import { teal, cyan, lightBlue, amber, green, common } from '@mui/material/colors'
import { createTheme, responsiveFontSizes } from '@mui/material/styles'

// A custom theme for this app
let theme1 = createTheme({
	palette: {
		primary: {
			main: teal[200],
			light: teal[100]
		},
		secondary: {
			main: teal.A700
		},
		text: {
			primary: '#555',
			secondary: '#999',
			accent: teal.A700
		},
		background: {
			default: common.white
		}
	}
})

theme1 = responsiveFontSizes(theme1)

// A custom theme for this app
let theme2 = createTheme({
	palette: {
		primary: {
			main: cyan[200],
			light: cyan[100]
		},
		secondary: {
			main: cyan.A700
		},
		text: {
			primary: '#555',
			secondary: '#999',
			accent: cyan.A700
		},
		background: {
			default: common.white
		}
	}
})

theme2 = responsiveFontSizes(theme2)

// A custom theme for this app
let theme3 = createTheme({
	palette: {
		primary: {
			main: lightBlue[200],
			light: lightBlue[100]
		},
		secondary: {
			main: lightBlue.A700
		},
		text: {
			primary: '#555',
			secondary: '#999',
			accent: lightBlue.A700
		},
		background: {
			default: common.white
		}
	}
})

theme3 = responsiveFontSizes(theme3)

// A custom theme for this app
let theme4 = createTheme({
	palette: {
		primary: {
			main: amber[200],
			light: amber[100]
		},
		secondary: {
			main: amber.A700
		},
		text: {
			primary: '#555',
			secondary: '#999',
			accent: amber.A700
		},
		background: {
			default: common.white
		}
	}
})

theme4 = responsiveFontSizes(theme4)

// A custom theme for this app
let theme5 = createTheme({
	palette: {
		primary: {
			main: green[200],
			light: green[100]
		},
		secondary: {
			main: green.A700
		},
		text: {
			primary: '#555',
			secondary: '#999',
			accent: green.A700
		},
		background: {
			default: common.white
		}
	}
})

theme5 = responsiveFontSizes(theme5)

// A custom theme for this app
let theme6 = createTheme({
	palette: {
		primary: {
			main: '#ecdf46',
			light: '#f6f1ad'
		},
		secondary: {
			main: '#afa212'
		},
		text: {
			primary: '#555',
			secondary: '#999',
			accent: '#afa212'
		},
		background: {
			default: common.white
		}
	}
})

theme6 = responsiveFontSizes(theme6)

// A custom theme for this app
let theme7 = createTheme({
	palette: {
		primary: {
			main: '#5c9be1',
			light: '#b6d3f2'
		},
		secondary: {
			main: '#2065b1'
		},
		text: {
			primary: '#555',
			secondary: '#999',
			accent: '#2065b1'
		},
		background: {
			default: common.white
		}
	}
})

theme7 = responsiveFontSizes(theme7)

// A custom theme for this app
let theme8 = createTheme({
	palette: {
		primary: {
			main: '#f25765',
			light: '#f9b4bb'
		},
		secondary: {
			main: '#d51022'
		},
		text: {
			primary: '#555',
			secondary: '#999',
			accent: '#d51022'
		},
		background: {
			default: common.white
		}
	}
})

theme8 = responsiveFontSizes(theme8)

export { theme1, theme2, theme3, theme4, theme5, theme6, theme7, theme8 }
